import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/orden_trabajo/searchOrdenesTrabajo.php';

export default function searchOrdenesTrabajo({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}